<div mat-dialog-title style="margin:0px;">Report to Archive - Processes</div>


<mat-dialog-content>
    <div style="padding: 10px; font-size: 10pt; font-style: italic;">
        Click refresh to update the status of your archiving process(es).
    </div>

    <table class="table reportTable" style="margin-bottom:0px;">
        <tr>
            <td style="padding-left:5px;">
                Status
            </td>
            <td> 
                <tyl-form-field>
                    <mat-select id="ProcessStatus" name="ProcessStatus" [(ngModel)]="selectedProcess"
                        (ngModelChange)="processChanged();">
                        <mat-option *ngFor="let process of processes" [value]="process.TextField">
                            {{process.TextField}}
                        </mat-option>
                    </mat-select>
                </tyl-form-field>
            </td>
            <td>
                <ng-container style="display:inline;">
                    <tyl-datepicker label="From" id="FromDate" [(value)]="fromDate"
                        (valueChange)="fromDateChanged()">
                    </tyl-datepicker>
                </ng-container>
            </td>
            <!-- <td>
                <tyl-form-field label="From Date">
                    <input matInput  name="FromDate2" [(ngModel)]="fromDate"
                        id="FromDate2" 
                        placeholder="From Date" >
                </tyl-form-field>
            </td> -->

            <td style="padding-left:5px;">
                    Added By
                </td>
                <td>
                    <tyl-form-field>
                        <mat-select id="addedby" name="addedby" [(ngModel)]="addedBy"
                            (ngModelChange)="processChanged();">
                            <mat-option *ngFor="let user of addedBys" [value]="user.TextField">
                                {{user.TextField}}
                            </mat-option>
                        </mat-select>
                    </tyl-form-field>
                </td>
        </tr>
    </table>

    <div class="divTable" style="height:85%; overflow:auto;">
        <table class="table reportTable" style="margin-bottom:0px;">
            <thead>
                <td style="padding-left:5px;">

                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Status
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Report
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Archive To
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Added On
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Added By
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    Total Students
                </td>
                <td style="padding-left:5px; font-weight: bold;">
                    # Completed
                </td>
            </thead>
            <tbody *ngFor="let Batch of filteredBatches">

                <tr>
                    <td style="padding-left:5px;">
                        <a *ngIf="allowCancelArchiveProcesses && Batch.InProcess" (click)="cancelClick(Batch)">Cancel</a>
                        <a *ngIf="Batch.NumberOfStudentsCompleted > 0 && allowDeleteArchivedReports && !Batch.InProcess" (click)="deleteClick(Batch)">Delete</a>
                    </td>
                    <td style="padding-left:5px;" [style.color] = "getStatusFontColor(Batch)">
                        {{ Batch.ProcessingDescription }}
                    </td>
                    <td style="padding-left:5px;">
                        {{ Batch.ReportName }}
                    </td>
                    <td style="padding-left:5px;">
                        {{ Batch.OperationDescriptions }}
                    </td>
                    <td style="padding-left:5px;">
                        {{ Batch.AddedOnDate_Display }}
                    </td>
                    <td style="padding-left:5px;">
                        {{ Batch.AddedByName }}
                    </td>
                    <td *ngIf="Batch.ShowTotalNumberOfStudents" style="padding-left:5px;">
                        {{ Batch.TotalNumberOfStudents }}
                    </td>
                    <td *ngIf="!Batch.ShowTotalNumberOfStudents" style="padding-left:5px;">
                        Unknown
                    </td>
                    <td style="padding-left:5px;">
                        {{ Batch.NumberOfStudentsCompleted }}
                    </td>
                </tr>
                <tr style="border-bottom: 1px solid silver">
                    <td></td>
                    <td></td>
                    <td colspan="6">
                        <span *ngIf="Batch.ErrMsg" style="color: red;">
                            {{ Batch.ErrMsg.substr(0, 200) }}<span *ngIf="Batch.ErrMsg && Batch.ErrMsg.length > 199">...</span>
                        </span>

                    </td>

                </tr>
            </tbody>
        </table>
    </div>

</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="refreshButton" image="refresh.png" label="Refresh" (clickEvent)="refreshClick()"></tyl-button>
        <tyl-button id="closeButton" image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>